import { propertyTypeMap } from 'root/widgets/constants';

export const getBasePropertyType = (typeName: string) =>
  Object.keys(propertyTypeMap).find((type) => propertyTypeMap[type].includes(typeName));
